import Icon from "@mdi/react";
import { mdiEye, mdiEyeOff } from "@mdi/js";
// components
import { dropDownOptions } from "components/DropDownMenu";

const visible = <Icon path={mdiEye} size={0.9} color="green" />;
const notVisible = <Icon path={mdiEyeOff} size={0.9} color="red" />;

export default class GetPublication {
	static getName(publication) {
		switch (publication) {
			case 0:
				return "Not visible";
			case 1:
				return "Visible";
		}
	}
	static getDropDownItem(published) {
		switch (published) {
			case 0:
				return new dropDownOptions(notVisible, "Not visible", "", 0);
			case 1:
				return new dropDownOptions(visible, "Visible", "", 1);
		}
	}
}
export const dropDownPublicationOptionsArray = [GetPublication.getDropDownItem(0), GetPublication.getDropDownItem(1)];
